import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-channel-selection-popover',
  templateUrl: './channel-selection-popover.component.html',
  styleUrls: ['./channel-selection-popover.component.scss'],
})
export class ChannelSelectionPopoverComponent implements OnInit {
  @Input() phoneNumber: string;
  @Input() prefix: string;
  selectedChannel: string = 'sms';

  constructor(private popoverController: PopoverController) {}

  ngOnInit() {}

  selectChannel(channel: string) {
    this.selectedChannel = channel;
  }

  confirm() {
    this.popoverController.dismiss({
      channel: this.selectedChannel,
      confirmed: true
    });
  }

  cancel() {
    this.popoverController.dismiss({
      confirmed: false
    });
  }
}